import React from 'react'
import NextImage from '../NextImage'

const LineStroke = () => {
    return (
        <NextImage
            src="https://ik.imagekit.io/hyqoo/WebsiteAssets/line-stroke.webp"
            alt='line-stroke'
            height={'2px'}
            width={'auto'}
            unoptimized
        />
    )
}

export default LineStroke
